import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadTotal: -1,
    loadDay: -1,
  },
  total: 0,
  totalDay: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.REPORT_APPOINTMENT_STATS_REQUESTED:
      return {
        ...state,
        status: {
          loadTotal: 0,
        },
      };
    case ACTION_TYPES.REPORT_APPOINTMENT_STATS_SUCCEED:
      return {
        ...state,
        status: {
          loadTotal: 1,
        },
        total: payload.data.total,
      };
    case ACTION_TYPES.REPORT_APPOINTMENT_STATS_FAILED:
      return {
        ...state,
        status: {
          loadTotal: 2,
        },
        error,
      };
    case ACTION_TYPES.REPORT_APPOINTMENT_DAY_STATS_REQUESTED:
      return {
        ...state,
        status: {
          loadDay: 0,
        },
      };
    case ACTION_TYPES.REPORT_APPOINTMENT_DAY_STATS_SUCCEED:
      return {
        ...state,
        status: {
          loadDay: 1,
        },
        totalDay: payload.data,
      };
    case ACTION_TYPES.REPORT_APPOINTMENT_DAY_STATS_FAILED:
      return {
        ...state,
        status: {
          loadDay: 2,
        },
        error,
      };
    default:
      return state;
  }
}
